import { render, staticRenderFns } from "./ReturnGoodsModule.vue?vue&type=template&id=144274f1"
import script from "./ReturnGoodsModule.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports